export { CrmScoringDefinitionModule } from './scoring-definition.module';
